import { Component, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';

import { DocsService } from '../../services/docs.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
    selector: 'kd-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    defaultRoute: string;
    label: string = environment.label;
    title: string = environment.title;

    constructor(
        private docsService: DocsService,
        private navigationService: NavigationService,
    ) { }

    ngOnInit() {
        this.defaultRoute = this.docsService.getDefaultRoute();
    }

    openMenu(): void {
        this.navigationService.openMenu();
    }
}
